var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { calculateDepositPercent } from '../../financial/deposit';
import { daysInYear, daysInMonths } from '../../utils/date';
import { getRate } from './depositFilters';
var Deposit = /** @class */ (function () {
    /**
     * @param {Array<DepositRate>} rates
     * @param {DepositInput} input
     */
    function Deposit(rates, input) {
        this.rates = rates;
        this.input = input;
    }
    /**
     * @return ResultEnvelope<Array<DepositOutput> | DepositOutputError>
     */
    Deposit.prototype.calculate = function () {
        var _this = this;
        var grid = [];
        var percentRates = [];
        var totalAmount = this.input.amount;
        try {
            grid = this.calculateGrid();
        }
        catch (e) {
            return this.getErrorResponse(e);
        }
        if (this.input.capitalized || this.input.refill > 0) {
            totalAmount = grid[grid.length - 1].amount;
        }
        grid.forEach(function (rec) {
            if (!_this.input.capitalized) {
                totalAmount += rec.percentAmount;
            }
        });
        percentRates.push(Math.min.apply(Math, __spread(grid.map(function (gridRecord) { return gridRecord.rate; }))));
        var rateMax = Math.max.apply(Math, __spread(grid.map(function (gridRecord) { return gridRecord.rate; })));
        if (!percentRates.includes(rateMax)) {
            percentRates.push(rateMax);
        }
        return {
            success: true,
            result: {
                grid: grid,
                percentRates: percentRates,
                totalAmount: totalAmount,
            },
        };
    };
    /**
     * @param input
     */
    Deposit.prototype.setInput = function (input) {
        this.input = input;
    };
    /**
     * @return Array<DepositGrid>
     */
    Deposit.prototype.calculateGrid = function () {
        var result = [];
        var input = Object.assign({}, this.input);
        input.dateStart = new Date(input.dateStart.getTime());
        input.dateStart.setDate(input.dateStart.getDate() + 1);
        if (input.termInDays === false) {
            input.term = daysInMonths(input.dateStart, this.input.term);
        }
        var periodDays = 0;
        var processedPeriodDays = 0;
        var isFirstPeriod = true;
        while (processedPeriodDays < input.term) {
            periodDays = this.getPeriodDays(input, processedPeriodDays);
            var isFullPeriod = this.isFullPeriod(input, processedPeriodDays);
            processedPeriodDays += periodDays;
            var depositRate = getRate(this.rates, input);
            this.checkRate(depositRate);
            var ratePercent = this.getRatePercent(depositRate);
            var percentAmount = calculateDepositPercent(input.amount, periodDays, depositRate.rate, daysInYear(input.dateStart));
            if (input.capitalized) {
                input.amount += percentAmount;
            }
            if (input.refill > 0 && !isFirstPeriod && isFullPeriod) {
                input.amount += input.refill;
            }
            result.push({
                period: periodDays,
                totalPeriod: processedPeriodDays,
                rate: ratePercent,
                rateCalc: depositRate.rate,
                amount: input.amount,
                percentAmount: percentAmount,
            });
            input.dateStart.setMonth(input.dateStart.getMonth() + 1);
            isFirstPeriod = false;
        }
        return result;
    };
    /**
     * @param {DepositRate} depositRate
     * @return number
     */
    Deposit.prototype.getRatePercent = function (depositRate) {
        if (this.input.capitalized) {
            return depositRate.capitalized_rate;
        }
        return depositRate.rate;
    };
    /**
     * @param {DepositInput} input
     * @param {number} processedPeriodDays
     * @return boolean
     */
    Deposit.prototype.getPeriodDays = function (input, processedPeriodDays) {
        var periodDays = daysInMonths(input.dateStart, 1);
        if (periodDays + processedPeriodDays > input.term) {
            periodDays = input.term - processedPeriodDays;
        }
        return periodDays;
    };
    /**
     * @param {DepositInput} input
     * @param {number} processedPeriodDays
     * @return boolean
     */
    Deposit.prototype.isFullPeriod = function (input, processedPeriodDays) {
        var periodDays = daysInMonths(input.dateStart, 1);
        return periodDays + processedPeriodDays <= input.term;
    };
    /**
     * @param {DepositRate} rate
     */
    Deposit.prototype.checkRate = function (rate) {
        if (this.input.capitalized && !rate.capitalized) {
            throw 'Rate does not imply capitalization';
        }
        if (this.input.refill && !rate.refill) {
            throw 'Rate does not imply refilling';
        }
    };
    /**
     * @param {string} message
     */
    Deposit.prototype.getErrorResponse = function (message) {
        return {
            success: false,
            result: {
                error: message,
            },
        };
    };
    return Deposit;
}());
export default Deposit;
